import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAusyP1_ZslrKvOZ5PLB-4TPCBhysn_jIc",
  authDomain: "fusco-c078b.firebaseapp.com",
  projectId: "fusco-c078b",
  storageBucket: "fusco-c078b.firebasestorage.app",
  messagingSenderId: "591760587587",
  appId: "1:591760587587:web:4c65ecc18f3ee54f798df6",
  measurementId: "G-D6VGC88V57"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Firestore veritabanını al
export const db = getFirestore(app);

// Analytics'i al (isteğe bağlı)
export const analytics = getAnalytics(app);

export default app; 